import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Typography,
  FormControl,
  TextField,
  CardContent,
  Grid,
  Button,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";
import Key from "../../../clientVariables.json";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { getCandidateDetailAction } from "../redux/action";
import { myCandidatesSelector } from "../redux/selector";
import { userSelector } from "../../user-redux/selector";

const ProfileSummary = ({ formDataHnadler }) => {
  const [formData, setFormData] = useState({
    USWorkAuthorization: "",
    visaValidityUntill: null,
    willingToRelocate: "",
    currentlyOnProject: "",
    interviewTimeSlots: "",
    availabilityForProject: "",
    ssnLast4Digits: "",
    certifications: "",
    videoInterviewAvailability: "",
    rate: "",
  });

  const dispatch = useDispatch();
  const { candidateDetails } = useSelector(myCandidatesSelector);
  const { user } = useSelector(userSelector);

  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleDateSelection = (dates) => {
    setSelectedDates(dates);
  };

  const handleTimeSlotSelection = (timeSlots) => {
    setSelectedTimeSlots(timeSlots);
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        setFormData({
          USWorkAuthorization: candidateDetails?.work_authorization
            ? candidateDetails?.work_authorization
            : "",
          visaValidityUntill:
            candidateDetails?.visa_validity_date &&
            candidateDetails?.visa_validity_date !== undefined &&
            candidateDetails?.visa_validity_date !== ""
              ? candidateDetails?.visa_validity_date
              : null,
          willingToRelocate: candidateDetails?.willing_to_relocate
            ? candidateDetails?.willing_to_relocate
            : "",
          currentlyOnProject: candidateDetails?.currently_on_project
            ? candidateDetails?.currently_on_project
            : "",
          interviewTimeSlots: candidateDetails?.interview_time_slots
            ? candidateDetails?.interview_time_slots
            : "",
          availabilityForProject: candidateDetails?.availability_for_project
            ? candidateDetails?.availability_for_project
            : "",
          ssnLast4Digits: candidateDetails?.ssn
            ? parseInt(candidateDetails?.ssn)
            : "",
          certifications: candidateDetails?.certifications
            ? candidateDetails?.certifications
            : "",
          videoInterviewAvailability:
            candidateDetails?.video_interview_availability
              ? candidateDetails?.video_interview_availability
              : "",
          rate: candidateDetails?.desired_salary
            ? candidateDetails?.desired_salary
            : "",
        });
        await formDataHnadler(formData, "f2");
      } catch (error) {
        console.error(error);
      }
    };
    fetch();
  }, [candidateDetails]);
  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleVisaValidityUntillChange = (date) => {
    setFormData({
      ...formData,
      visaValidityUntill: moment(date).format("MM-YYYY"),
    });
  };

  const handleTimeSlotsSelection = (date, timeSlots) => {
    // Store selected date and time slots in the form data state
    setFormData({
      ...formData,
      interviewTimeSlots: {
        date: date,
        timeSlots: timeSlots,
      },
    });
  };

  const handleSSNInputChange = (fieldName) => (event) => {
    const inputValue = event.target.value;
    // Ensure only numeric values are allowed
    const numericValue = inputValue.replace(/\D/g, "");
    // Update the state with the numeric value
    setFormData({
      ...formData,
      [fieldName]: numericValue.slice(0, 4), // Limit to 4 digits
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    await formDataHnadler(formData, "f2");

    try {
      const response = await axios.post(
        `${Key.domain}/candidate/update/professional/${candidateDetails?.candidate_id}`,
        {
          work_authorization: formData.USWorkAuthorization,
          visa_validity_date: formData.visaValidityUntill,
          willing_to_relocate: formData.willingToRelocate,
          currently_on_project: formData.currentlyOnProject,
          interview_time_slots: formData.interviewTimeSlots,
          availability_for_project: formData.availabilityForProject,
          candidate_rate: formData.rate,
          video_interview_availability: formData.videoInterviewAvailability,
          ssn_last_four_digits: formData.ssnLast4Digits,
          candidate_certifications: formData.certifications,
        }
      );
      dispatch(
        getCandidateDetailAction(candidateDetails?.candidate_id, user?.id)
      );
      handleOpenSnackbar("candidate details updated successfully", "success");
    } catch (error) {
      console.error(error);
      handleOpenSnackbar("Something went wrong", "error");
    }
    setIsSubmitting(false);
  };

  return (
    <Card sx={cardStyles}>
      <CardHeader
        title={
          <Typography variant="h6" sx={headerStyles}>
            Update professional Details
          </Typography>
        }
      />
      <CardContent
        sx={{
          ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
            padding: "8px 6px",
          },
          ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
            { padding: "8px 6px" },
          ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
            padding: "8px 6px",
          },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  US Work Authorization
                </Typography>
                <Select
                  labelId="USWorkAuthorization-label"
                  id="USWorkAuthorization"
                  label=""
                  placeholder="H1B"
                  value={formData.USWorkAuthorization}
                  onChange={(event) =>
                    setFormData({
                      ...formData,
                      USWorkAuthorization: event.target.value,
                    })
                  }
                  sx={inputStyles}
                >
                  <MenuItem value="" disabled>
                    Select Work Authorization
                  </MenuItem>
                  <MenuItem value="H1">H1</MenuItem>
                  <MenuItem value="H4-EAD">H4-EAD</MenuItem>
                  <MenuItem value="OPT">OPT</MenuItem>
                  <MenuItem value="OPT-EAD">OPT-EAD</MenuItem>
                  <MenuItem value="CPT">CPT</MenuItem>
                  <MenuItem value="CPT-EAD">CPT-EAD</MenuItem>
                  <MenuItem value="L1">L1</MenuItem>
                  <MenuItem value="L2-EAD">L2-EAD</MenuItem>
                  <MenuItem value="GREEN CARD">GREEN CARD</MenuItem>
                  <MenuItem value="US CITIZEN">US CITIZEN</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              dateLibInstance={moment}
            >
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <Typography paragraph sx={labelStyles}>
                    Visa Validity Until
                  </Typography>

                  <DatePicker
                    sx={inputStyles}
                    // value={formData.visaValidityUntill}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="MM/YYYY"
                        sx={inputStyles}
                      />
                    )}
                    value={
                      formData.visaValidityUntill
                        ? moment(formData.visaValidityUntill, "MM/YYYY")
                        : null
                    }
                    onChange={handleVisaValidityUntillChange}
                    views={["year", "month"]}
                    openTo="year"
                    // format="MM/YYYY"
                    minDate={moment().startOf("year")}
                  />
                </FormControl>
              </Grid>
            </LocalizationProvider>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Willing to Relocate
                </Typography>
                <Select
                  labelId="willingToRelocate-label"
                  id="willingToRelocate"
                  value={formData.willingToRelocate}
                  onChange={handleInputChange("willingToRelocate")}
                >
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Currently on Project
                </Typography>
                <Select
                  labelId="currentlyOnProject-label"
                  id="currentlyOnProject"
                  value={formData.currentlyOnProject}
                  onChange={handleInputChange("currentlyOnProject")}
                >
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Video Interview Availability
                </Typography>
                <Select
                  labelId="videoInterviewAvailability-label"
                  id="videoInterviewAvailability"
                  value={formData.videoInterviewAvailability}
                  onChange={handleInputChange("videoInterviewAvailability")}
                >
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12}>
          <InterviewDateSelector onSelectDates={handleDateSelection} />
        </Grid>
        <Grid item xs={12}>
          {selectedDates.length > 0 && (
            <InterviewTimeSlotSelector
              selectedDates={selectedDates}
              onSelectTimeSlots={handleTimeSlotSelection}
            />
          )}
        </Grid> */}
            <Grid item xs={6}>
              {/* <InterviewTimeSlotsForVendor onSelectTimeSlots={handleTimeSlotsSelection} /> */}
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Interview Time Slots
                </Typography>
                <TextField
                  id="interviewTimeSlots"
                  label=""
                  variant="outlined"
                  placeholder="--"
                  value={formData.interviewTimeSlots}
                  onChange={handleInputChange("interviewTimeSlots")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Availability For Project
                </Typography>
                <TextField
                  id="availabilityForProject"
                  label=""
                  variant="outlined"
                  placeholder="--"
                  value={formData.availabilityForProject}
                  onChange={handleInputChange("availabilityForProject")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Any Certifications
                </Typography>
                <TextField
                  id="certifications"
                  label=""
                  variant="outlined"
                  placeholder="--"
                  value={formData.certifications}
                  onChange={handleInputChange("certifications")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  Rate
                </Typography>
                <TextField
                  id="rate"
                  label=""
                  variant="outlined"
                  placeholder="--"
                  value={formData.rate}
                  onChange={handleInputChange("rate")}
                  sx={inputStyles}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <Typography paragraph sx={labelStyles}>
                  SSN Last 4 Digits
                </Typography>
                <TextField
                  id="ssnLast4Digits"
                  label=""
                  variant="outlined"
                  placeholder="--"
                  value={formData.ssnLast4Digits}
                  onChange={handleSSNInputChange("ssnLast4Digits")}
                  sx={inputStyles}
                  inputProps={{
                    maxLength: 4,
                    pattern: "\\d{4}", // Regular expression to allow only 4 digits
                    title: "Must be exactly 4 digits long",
                  }}
                  error={!/^\d{4}$/.test(formData.ssnLast4Digits)} // Check if input is not exactly 4 digits
                  helperText={
                    !/^\d{4}$/.test(formData.ssnLast4Digits)
                      ? "Must be exactly 4 digits long"
                      : ""
                  }
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} textAlign="end">
              <Button
                type="submit"
                variant="contained"
                sx={{ bgcolor: "#406882" }}
              >
                {isSubmitting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Card>
  );
};

export default ProfileSummary;

const cardStyles = {
  boxShadow: "none",
  borderRadius: "8px",
};

const headerStyles = {
  color: "rgb(102, 120, 156)",
  fontSize: "16px",
  fontWeight: 600,
};

const labelStyles = {
  color: "rgb(160, 171, 184)",
  marginBottom: "5px",
};

const inputStyles = {
  border: "1px solid 	rgb(224, 230, 247)",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid 	rgb(224, 230, 247)",
    borderRadius: "4px",
  },
};
